<template>
  <div>
    <osv-app-alert />

    <div class="columns is-multiline post-list">
      <div
        class="column is-one-third"
        v-for="post in this.posts"
        :key="post.id"
      >
        <a class="discrete-link" :href="postPath(post.id)">
          <div class="card">
            <div class="card-image">
              <figure class="image is-2by1">
                <img :src="post.image" :alt="post.name" />
              </figure>
            </div>
            <div class="card-content">
              <div class="media">
                <div class="media-content">
                  <p class="title is-6">
                    {{ post.name }}
                  </p>
                  <p class="subtitle is-6 text-grey pt-1">
                    {{ post.hours_per_week }} |
                    {{ startMonth(post.start_date) | capitalize }}
                  </p>
                </div>
              </div>
              <div class="content">
                {{ post.summary }}
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Spinner --->
    <div class="text-center" v-if="this.loading">
      <spinner />
    </div>

    <!-- If I don't have a post yet --->
    <div v-if="this.posts.length === 0 && this.loading === false">
      <p class="text-grey text-center">
        <cite>{{ $t("noPost") }}</cite>
      </p>
    </div>
  </div>
</template>

<script>
import { HelpersMixin } from "@/mixins/HelpersMixin";
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import cug from "@/services/cug";
import moment from "@/services/momentjs";
import Spinner from "./shared/Spinner";
import VueI18n from "vue-i18n";
import OsvAppAlert from "@/components/shared/OsvAppAlert";

export default {
  name: "RecruitmentPostList",
  components: { OsvAppAlert, Spinner },
  mixins: [LocaleMixin, HelpersMixin, ConfigMixin],

  data() {
    return {
      posts: [],
      loading: true
    };
  },

  beforeMount() {
    cug
      .recruitmentPostList()
      .then(rep => {
        this.posts = rep.data;
      })
      .catch(err => {
        this.$root.$emit("OsvAlert_ErrorFromApi", err, "recruitment");
      })
      .finally(() => {
        this.loading = false;
      });
  },

  methods: {
    startMonth: function(start_date) {
      if (start_date) {
        return moment(start_date).format("MMMM YYYY");
      } else {
        return this.$t("asSoonAsPossible");
      }
    },

    postPath: function(postId) {
      return `${this.osvConfig.paths.recruitmentPost}?recruitment_post=${postId}`;
    }
  },

  // Translate component
  mounted() {
    this.$i18n.locale = this.getLocale();
  },
  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        noPost: "Sorry, there are no jobs available at the moment.",
        seeOffer: "See offer",
        asSoonAsPossible: "As soon as possible"
      },
      fr: {
        noPost: "Désolé, il n'y a pas de poste à pourvoir en ce moment.",
        seeOffer: "Voir l'offre",
        asSoonAsPossible: "Dès que possible"
      }
    }
  })
};
</script>

<style lang="scss" src="../assets/styles/buefy/base.scss"></style>
<style lang="scss">
.post-list {
  .card {
    height: 100%;
    .image {
      img {
        object-fit: cover;
      }
    }
    &:hover {
      opacity: 0.8;
    }
    .card-content {
      padding: 1rem;
      .media {
        margin-bottom: 1rem;
      }
    }
    .subtitle {
      overflow: hidden;
    }
  }
}
</style>
